import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-gradient-to-br from-petrol-600 to-petrol-700" data-id="element-61">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-62">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-63"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/20 to-transparent" data-id="element-64"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10 text-center" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-66">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-tight" data-id="element-67">
            Speakers You Can Trust to Deliver Measurable Impact
          </h1>

          <p className="text-lg md:text-xl text-cream-100/90 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-68">
            Goldspeakers connects organisations with handpicked speakers known
            for real-world expertise, audience connection, and business-relevant
            transformation. Every name in our portfolio is vetted for one thing:
            ROI you can feel in the room.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-69">
            <button className="w-full sm:w-auto bg-gold-500 hover:bg-gold-400 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-70">
              <span data-id="element-71">✦</span> Request Speaker Match
            </button>

            <button className="w-full sm:w-auto bg-transparent border-2 border-white/30 hover:border-white text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all hover:bg-white/10 flex items-center justify-center gap-2 group" data-id="element-72">
              Download Sample Profiles
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-73" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}